// Language helpers for CMS twins (LandingPage / BlogArticle with `lang` + `alt_slug`).
// EN records store their slug WITHOUT "en/" and are served only at /en/<slug>.
// Records without `lang` are Greek.
import EN_CMS from './enCmsSlugs.generated.json';

const SITE_URL = 'https://ikonomakis.gr';

export const recordLang = (r) => (r?.lang === 'en' ? 'en' : 'el');
export const isEnRecord = (r) => recordLang(r) === 'en';
export const cmsPath = (slug, lang) => (lang === 'en' ? `/en/${slug}` : `/${slug}`);

// Built from data at build time (scripts/vite-plugin-seo-static.mjs).
// '/<greek-slug>' → '/en/<en-slug>' for every EN CMS record with alt_slug.
export const EN_CMS_PAIRS = Object.fromEntries(
  (Array.isArray(EN_CMS) ? EN_CMS : [])
    .filter((e) => e?.slug && e?.alt_slug)
    .map((e) => [`/${String(e.alt_slug).replace(/^\/+/, '')}`, `/en/${e.slug}`]),
);
export const EN_CMS_TO_EL = Object.fromEntries(Object.entries(EN_CMS_PAIRS).map(([el, en]) => [en, el]));

// Replace all hreflang alternates with an el-GR / en / x-default (Greek) set.
export function setHreflangPair(elPath, enPath) {
  if (typeof document === 'undefined' || !elPath || !enPath) return;
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove());
  const elHref = elPath === '/' ? `${SITE_URL}/` : `${SITE_URL}${elPath}`;
  [['el-GR', elHref], ['en', `${SITE_URL}${enPath}`], ['x-default', elHref]].forEach(([hl, href]) => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = hl;
    link.href = href;
    document.head.appendChild(link);
  });
}

// Twin path for a loaded record: EN record → its Greek alt_slug; Greek record → EN twin
// from build data, the function's `alternate`, or its own alt_slug.
export function twinPath(record, lang, alternate) {
  if (!record?.slug) return null;
  if (alternate?.path) return alternate.path;
  if (lang === 'en') return record.alt_slug ? `/${String(record.alt_slug).replace(/^\/+/, '')}` : (EN_CMS_TO_EL[`/en/${record.slug}`] || null);
  if (EN_CMS_PAIRS[`/${record.slug}`]) return EN_CMS_PAIRS[`/${record.slug}`];
  return record.alt_slug ? `/en/${String(record.alt_slug).replace(/^\/?(en\/)?/, '')}` : null;
}
